"use client";

import { useCallback } from "react";
import { useStorageQuery } from "./storageQueryProvider";
import { ViewingScope } from "./viewingPreferences";
import { View } from "../components/grids/types";

export function usePersistedView(scope: ViewingScope) {
    const { views, updateView } = useStorageQuery();

    const setView = useCallback(
        (view: View) => updateView(scope, view),
        [updateView, scope]
    );

    return [views[scope], setView] as const;
}
